/**
 * 기능 모드 매핑
 * 작업자: 젠이츠
 */

import { VIEW_MODES } from "./viewModes";

/**
 * 뷰 모드별 기능 모드 텍스트 매핑
 */
export const FUNCTION_MODES = {
    [VIEW_MODES.TABLE_VIEW]: "일반 현황",
    [VIEW_MODES.TILE_VIEW]: "타일형",
    [VIEW_MODES.ORG_CHART]: "구성 분석",
    [VIEW_MODES.FLOW_CHART]: "흐름 분석",
    [VIEW_MODES.PATTERN_CHART]: "패턴 분석",
    [VIEW_MODES.SCATTER_CHART]: "상관 분석",
    [VIEW_MODES.STACK_CHART]: "성분 분석",
    [VIEW_MODES.EQUIP_CHART]: "트랜드1형",
    [VIEW_MODES.PROP_CHART]: "트랜드2형",
    [VIEW_MODES.DATA_BASE]: "데이터보기",
};

/**
 * 기능 모드 텍스트 가져오기
 * @param {string} viewMode - 뷰 모드
 * @returns {string} 기능 모드 텍스트
 */
export const getFunctionModeText = (viewMode) => {
    return FUNCTION_MODES[viewMode] || "일반 현황";
};
